import { Eye, EyeOff } from "lucide-react"; // Importing icons from Lucide
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SpinnerBorder } from "./Spinner/Spinner";
// import style from "./Spinner/Spinner.module.css";
const PwReset = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(""); // New state for error messages

  let isValid = false;

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isSendSuccessfull, setIsSendSuccessfull] = useState(false);

  let ungültig = "";
  let t = searchParams.get("token");
  if (t !== null) {
    const payload = parseJwt(t);
    if (Date.now() >= payload.exp * 1000) {
      ungültig = "Ungültiger/abgelaufener Token!";
      isValid = false;
    } else {
      isValid = true;
    }
  } else {
    ungültig = "Kein Token vorhanden! Ungültiger Aufruf!";
    isValid = false;
  }

  function parseJwt(token: string) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  }

  const validatePassword = (password: any) => {
    const minLength = 8;
    const hasNumber = /\d/;
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;
    const hasCapitalLetter = /[A-Z]/;

    if (password.length < minLength) {
      return "Das Passwort muss mindestens 8 Zeichen lang sein.";
    }
    if (!hasNumber.test(password)) {
      return "Das Passwort muss mindestens eine Zahl enthalten.";
    }
    if (!hasSpecialChar.test(password)) {
      return "Das Passwort muss mindestens ein Sonderzeichen enthalten.";
    }
    if (!hasCapitalLetter.test(password)) {
      return "Das Passwort muss mindestens einen Großbuchstaben enthalten.";
    }
    return null;
  };

  const putNewPassword = async () => {
    try {
      const url = "https://qas.freyadv.de/eserviceschein/changePassword/";

      const raw = JSON.stringify({
        token: t,
        newPassword: newPassword,
      });

      await fetch(url, {
        method: "Put",
        headers: {
          // Authorization: `${token}`, for later
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "http://localhost:3000/serviceschein",
        },
        body: raw,
      })
        .then((response) => {
          if (response.status !== 200) {
            alert(`Fehler! Nicht möglich - ${response.status}`);
            return null;
          }

          // return response.json();
          return;
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      alert(error);
    }
  };

  const handlePasswordChange = (e: any) => {
    setNewPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e: any) => {
    setConfirmPassword(e.target.value);
  };

  const delay = (ms: number | undefined) =>
    new Promise((res) => setTimeout(res, ms));
  // let isSetSuccessfull: boolean = false;

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const passwordError = validatePassword(newPassword);
    if (passwordError) {
      setError(passwordError);
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Die Passwörter stimmen nicht überein.");
      return;
    }
    setError(""); // Clear error if validation passes
    setLoading(true);
    await putNewPassword();
    await delay(1500);
    setLoading(false);
    setIsSendSuccessfull(true);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleClickToSignIn = () => {
    navigate("/login");
  };

  return (
    <>
      {isValid ? (
        <div className="flex items-center justify-center mt-5">
          <div className="bg-[#E4E4E4] p-4 rounded-lg w-[40%]">
            <form onSubmit={handleSubmit}>
              <div className="flex text-[#003C78] text-2xl mb-5 text-center">
                Neues Passwort erstellen
              </div>
              <div className="form-group mb-4">
                <div className="flex justify-between">
                  <label
                    htmlFor="newPassword"
                    className="block mb-2 text-gray-500"
                  >
                    Neues Passwort:
                  </label>
                </div>

                <div className="flex items-center">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="newPassword"
                    value={newPassword}
                    onChange={handlePasswordChange}
                    required
                    className="password-input flex-1 p-2 border rounded-l-lg"
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="bg-gray-300 p-2.5 rounded-r-lg"
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
              </div>
              <div className="form-group mb-4">
                <label
                  htmlFor="confirmPassword"
                  className="block mb-2 text-gray-500"
                >
                  Wiederholen:
                </label>
                <div className="flex items-center">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={handleConfirmPasswordChange}
                    required
                    className="password-input flex-1 p-2 border rounded-l-lg"
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="bg-gray-300 p-2.5 rounded-r-lg"
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
              </div>
              {error && (
                <div className="error-message text-red-500 mb-4">{error}</div>
              )}
              <div className="flex justify-center">
                {isSendSuccessfull ? (
                  <div className="flex-row justify-center items-center">
                    <div>
                      <span>Passwort erfolgreich geändert!</span>
                    </div>
                    <div className="flex justify-center">
                      <button
                        onClick={handleClickToSignIn}
                        className="p-2 mt-2 bg-[#002D5F] border-2 border-white rounded shadow-none font-bold text-13 text-white cursor-pointer hover:bg-[#0096D2]"
                      >
                        Zur Anmeldung
                      </button>
                    </div>
                  </div>
                ) : (
                  <button
                    type="submit"
                    disabled={loading}
                    className="flex items-center justify-center submit-button bg-blue-500 hover:bg-blue-700 text-white p-2 rounded-lg mx-auto w-1/3"
                  >
                    {loading ? <SpinnerBorder /> : "Bestätigen"}
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      ) : (
        <div>
          <h2 className="p-2 m-5 w-auto justify-center align-center text-center text-[#002D5F] border-2 border-white rounded shadow-none font-bold text-13 ">
            {ungültig}
          </h2>
          <div className="flex items-center justify-center">
            <button
              className="p-2 mr-2 bg-[#002D5F] border-2 border-white rounded shadow-none font-bold text-13 text-white cursor-pointer hover:bg-[#0096D2]"
              onClick={handleClickToSignIn}
            >
              Zurück zur Anmeldung
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default PwReset;
